"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScriptTable = exports.StatusColors = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_table_1 = require("react-table");
const react_bootstrap_1 = require("react-bootstrap");
const react_virtual_1 = require("@tanstack/react-virtual");
const schemaComponents_1 = require("@/schemaComponents");
const classes = __importStar(require("./ScriptTable.module.scss"));
require("./ScriptTableMobile.scss");
const color_1 = require("common/color");
exports.StatusColors = {
    unfinished: "#fde047b5",
    translated: "#16a34ab5",
    corrected: "#3b82f6b5",
};
const ScriptTable = function Table({ data, schema, hasMore, fetching, editPath, selectedIndex, splitMode, langId, highlightUnfinished, highlightByStatus, multipleSelection, selectedIndexes, select, selectAll, operationMode, }) {
    const columns = (0, react_1.useMemo)(() => (0, schemaComponents_1.propertiesToColumns)(schema.properties), [schema.properties]);
    const selectedRef = react_1.default.useRef(null);
    const { getTableProps, getTableBodyProps, headerGroups, rows: list, prepareRow, } = (0, react_table_1.useTable)({
        columns,
        data,
        autoResetPage: false,
    });
    const parentRef = react_1.default.useRef(null);
    const listHeight = 29;
    const virtualizer = (0, react_virtual_1.useVirtualizer)({
        count: list.length,
        getScrollElement: () => parentRef.current,
        estimateSize: () => listHeight,
        initialOffset: Math.max(selectedIndex, 0) * listHeight,
    });
    (0, react_1.useEffect)(() => {
        virtualizer.scrollToOffset(selectedIndex * listHeight, {
            behavior: "smooth",
        });
    }, [selectedIndex, virtualizer]);
    const isRowDisabled = (row) => {
        if (!operationMode || !langId)
            return false;
        const status = row.values[`translationStatus.${langId}`];
        if (operationMode === "corrector") {
            // If corrector, disable rows that are not "翻訳済み" (translated)
            return status !== "translated";
        }
        else if (operationMode === "translator") {
            // If translator, disable rows that are "校閲済み" (corrected)
            return status === "corrected";
        }
        return false;
    };
    const handleClickRow = (row) => {
        if (isRowDisabled(row))
            return;
        select === null || select === void 0 ? void 0 : select(row.original);
    };
    return (react_1.default.createElement("div", { ref: parentRef, className: (0, classnames_1.default)(classes["table-wrapper"], "scriptTable", "enableScrollbar"), style: {
            height: "100%",
            overflow: "auto",
        } },
        react_1.default.createElement("div", { className: "table-main", style: { height: `${virtualizer.getTotalSize() + 50}px` } },
            react_1.default.createElement("table", Object.assign({ className: "common-table table is-striped is-hoverable" }, getTableProps()),
                react_1.default.createElement("thead", { className: classes["table-header"] }, headerGroups.map((headerGroup, headerGroupIndex) => (react_1.default.createElement("tr", Object.assign({}, headerGroup.getHeaderGroupProps(), { key: headerGroupIndex }),
                    react_1.default.createElement("th", { style: { width: "1%", minWidth: 0 } },
                        react_1.default.createElement(react_bootstrap_1.FormCheck, { onChange: (e) => {
                                selectAll === null || selectAll === void 0 ? void 0 : selectAll(e.target.checked);
                            }, checked: multipleSelection &&
                                (selectedIndexes === null || selectedIndexes === void 0 ? void 0 : selectedIndexes.length) === list.length, style: { opacity: multipleSelection ? 1 : 0, height: 20 } })),
                    headerGroup.headers.map((column, columnIndex) => (react_1.default.createElement("th", { className: (0, classnames_1.default)({ [classes.isCurrentSort]: column.isSorted }, { [classes.isSortable]: column.canSort && !hasMore }, classes.cell), key: columnIndex, style: { width: column.width, fontWeight: 700 } },
                        react_1.default.createElement("div", null,
                            column.render("Header"),
                            column.isSorted && (react_1.default.createElement("span", { className: "icon" },
                                react_1.default.createElement("i", { className: (0, classnames_1.default)("mdi", classes.tableIcon, { "mdi-arrow-down": column.isSortedDesc }, { "mdi-arrow-up": !column.isSortedDesc }) }))))))))))),
                react_1.default.createElement("tbody", Object.assign({}, getTableBodyProps()), virtualizer.getVirtualItems().map((virtualRow, index) => {
                    var _a;
                    const row = list[virtualRow.index];
                    prepareRow(row);
                    const rowIsSelected = multipleSelection
                        ? selectedIndexes === null || selectedIndexes === void 0 ? void 0 : selectedIndexes.includes(virtualRow.index)
                        : selectedIndex === virtualRow.index;
                    const unFinished = !row.values[`translations.${langId}`];
                    const status = (_a = row.values[`translationStatus.${langId}`]) !== null && _a !== void 0 ? _a : "null";
                    const rowDisabled = isRowDisabled(row);
                    return (react_1.default.createElement("tr", Object.assign({}, row.getRowProps(), { key: row.id, style: {
                            height: `${virtualRow.size}px`,
                            transform: `translateY(${virtualRow.start - index * virtualRow.size}px)`,
                        }, onClick: () => handleClickRow(row), className: (0, classnames_1.default)({ isSelected: rowIsSelected }, { unFinished: highlightUnfinished && unFinished }, { [classes["disabled-row"]]: rowDisabled }), ref: rowIsSelected ? selectedRef : undefined }),
                        react_1.default.createElement("td", { style: { width: "1%", height: 20 } },
                            react_1.default.createElement(react_bootstrap_1.FormCheck, { checked: rowIsSelected, style: {
                                    opacity: multipleSelection ? 1 : 0,
                                    height: 20,
                                }, disabled: rowDisabled })),
                        row.cells.map((cell, columnIndex) => {
                            var _a, _b;
                            return (react_1.default.createElement("td", Object.assign({ "data-label": cell.column.Header }, cell.getCellProps(), { "data-tooltip-id": "tooltip-multiline", "data-tooltip-content": columnIndex >= 3 ? undefined : cell.value, "data-tooltip-delay-show": 100, "data-tooltip-delay-hide": 100, style: {
                                    backgroundColor: highlightByStatus
                                        ? color_1.statusColor[status]
                                        : undefined,
                                    height: 20,
                                    fontSize: 14,
                                } }),
                                react_1.default.createElement("div", { className: classes.cell },
                                    cell.render("Cell"),
                                    cell.column.id === `translationStatus.${langId}` &&
                                        (
                                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                        // @ts-ignore
                                        (_b = (_a = data[virtualRow.index]) === null || _a === void 0 ? void 0 : _a["tags"]) === null || _b === void 0 ? void 0 : _b.includes("skipped")) && react_1.default.createElement("span", null, "(\u4FDD\u7559)"))));
                        })));
                }))),
            react_1.default.createElement("div", null, fetching && react_1.default.createElement(react_bootstrap_1.Spinner, { animation: "border", size: "sm" })))));
};
exports.ScriptTable = ScriptTable;
